import * as React from "react";

const s = require("./Avatar.scss");

const placeHolder = require("./placeholder.png");
const groupPlaceHolder = require("./group_placeholder.png");

interface IAvatarProps {
    size?: string;
    image?: string;
    group?: boolean;
    onEdit?: () => any;
    className?: string;
};

interface IAvatarState {};

class Avatar extends React.Component<IAvatarProps, IAvatarState> {
    public render(): JSX.Element {
        const image = this.props.image;

        return (
            <div className={s.avatar + " " +  (this.props.size ? s[this.props.size] : "medium") + " " + (this.props.className || "")}>
                <div className={s.img} style={{
                    backgroundImage: "url(" + (image && image !== "undefined" ? image : (this.props.group ? groupPlaceHolder : placeHolder)) + ")"
                }}/>
            </div>
        );
    }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar/index.tsx